var map = {
	"./fons_cardio.webp": [
		7961,
		[
			961
		]
	],
	"./fons_gine.webp": [
		7626,
		[
			626
		]
	],
	"./fons_vallhebron.webp": [
		8656,
		[
			656
		]
	]
};
function webpackAsyncContext(req) {
	try {
		if(!__webpack_require__.o(map, req)) {
			return Promise.resolve().then(function() {
	var e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
		}
	} catch(err) {
		return Promise.reject(err);
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1][0]).then(function() { return __webpack_require__.t(id, 1 | 16); });
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 7941;
module.exports = webpackAsyncContext;